





















































































import { Component, Vue } from 'vue-property-decorator'
import HeaderNavigationDropdown from '@/components/layout/header/navigation/HeaderNavigationDropdown.vue'
import RouteName from '@/utils/RouteName'
import TranslationModule from '@/utils/TranslationModule'
import HeaderNavigationItemTitle from '@/components/layout/header/navigation/HeaderNavigationItemTitle.vue'
import EvaIcon from '@/components/svg-components/EvaIcon.vue'
import HeaderNewsletterCard from '@/components/layout/header/HeaderNewsletterCard.vue'
import { Header } from '@/types/Header.type'
import { GetArticlesResponse } from '@/types/response/GetArticlesResponse'
import BaseIcon from '@/components/reusable-components/basics/BaseIcon.vue'
import { ArticlePublishersName } from '@/types/ressources/Ressource.type'
import APIStrapi from '@/services/ApiStrapi'
import { StrapiVideo } from '@/types/strapi/Strapi.type'

@Component({
    components: { HeaderNewsletterCard, EvaIcon, HeaderNavigationItemTitle, HeaderNavigationDropdown, BaseIcon },
})
export default class HeaderResourceNavigation extends Vue {
    RouteName: typeof RouteName = RouteName
    TranslationModule: typeof TranslationModule = TranslationModule
    articlesList: GetArticlesResponse = []
    videoList: StrapiVideo[] = []
    CLUB_BASE_URL = process.env.VUE_APP_CLUB_BASE_URL

    async mounted() {
        this.articlesList = await APIStrapi.getArticles()
        this.videoList = await APIStrapi.getVideoList({ limit: 3, publisher: ArticlePublishersName.CLUB })
    }

    get config(): Header | null {
        return this.$store.state.app.headerConfiguration
    }
}
